import * as React from 'react';
import { ActionIcon, Flex } from "@mantine/core";
import { IconPencil, IconTrash } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import useStore from '../../store';

interface RowAction {
    icon: React.ReactNode;
    onClick: () => void;
}

interface ActionIconsProps {
    id: string;
    clientRoute?: string;
    deleteRecord?: (id: string) => void;
    customActions?: RowAction[];
}

const RowActions = ({
    clientRoute,
    id,
    deleteRecord,
    customActions
}: ActionIconsProps) => {

    const roleName = useStore(state => state.auth.roleName) ?? '';
    const navigate = useNavigate();

    return (
        <Flex
            justify={'flex-end'}
            align={'center'}
        >
            {
                customActions?.map((action, index) => {
                    return (
                        <ActionIcon color={'blue'} onClick={action.onClick} key={index}>
                            {action.icon}
                        </ActionIcon>
                    )
                })
            }
            {
                clientRoute && (
                    <ActionIcon color={'blue'} onClick={() => navigate(`${clientRoute}/edit`, { state: id })}>
                        <IconPencil size={18}/>
                    </ActionIcon>
                )
            }
            {
                deleteRecord && roleName.toLowerCase() === 'super' && (
                    <ActionIcon color={'red'} onClick={() => deleteRecord(id)}>
                        <IconTrash size={18}/>
                    </ActionIcon>
                )
            }
        </Flex>
    )
};

export default RowActions;